var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.375q1.125 0 1.917-.792.791-.791.791-1.916t-.791-1.917q-.792-.792-1.917-.792t-1.917.792q-.791.792-.791 1.917t.791 1.916q.792.792 1.917.792Zm0 14.167q5.375-4.792 8.104-9.104 2.729-4.313 2.729-7.438 0-4.917-3.125-8.042T20 5.833q-4.583 0-7.708 3.125T9.167 17q0 3.125 2.771 7.438 2.77 4.312 8.062 9.104Zm0 2.791q-6.5-5.666-9.708-10.5Q7.083 21 7.083 17q0-6.042 3.896-9.646Q14.875 3.75 20 3.75q5.125 0 9.021 3.604 3.896 3.604 3.896 9.646 0 4-3.209 8.833Q26.5 30.667 20 36.333ZM20 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5dcf933d43f98715881becf51a114a76.svg";
export { ForwardRef as ReactComponent };